var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "folder",
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.016,
    height: 124.493,
    viewBox: "0 0 145.016 124.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M121.721,53.277H87.365A15.17,15.17,0,0,1,72.207,38.118a4.051,4.051,0,0,0-4.068-4.068H23.3A23.331,23.331,0,0,0,0,57.345v77.9a23.331,23.331,0,0,0,23.3,23.3h98.425a23.331,23.331,0,0,0,23.3-23.3V76.542A23.305,23.305,0,0,0,121.721,53.277Zm15.159,81.941a15.17,15.17,0,0,1-15.159,15.159H23.3A15.17,15.17,0,0,1,8.137,135.218V57.345A15.17,15.17,0,0,1,23.3,42.187H64.432A23.334,23.334,0,0,0,87.365,61.414h34.355a15.17,15.17,0,0,1,15.159,15.159v58.645Z",
    transform: "translate(0 -34.05)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.8bea4ef2.svg";
export { ForwardRef as ReactComponent };